export const getBackEnd = () => {
  //let backendUrl = 'https://staging-back.wehealthy.ar';
  let backendUrl = 'http://localhost:3001';

  if (process.env.REACT_APP_API_URL) {
    backendUrl = process.env.REACT_APP_API_URL;
  }
  return backendUrl;
};
